import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import parser from 'html-react-parser';
import React, { useState } from 'react';

import '@css/fade-in.css';

const ApproachPrincipalBuilder = ({ block }) => {
  const [isShown, setIsShown] = useState(false);

  const handleClick = () => setIsShown(s => !s);

  return (
    <div className='offer-blue-row'>
      <div className='offer-image-col'>
        <GatsbyImage
          image={getImage(block.contentCards6CardIcon?.localFile)}
          alt='image'
        />
      </div>
      <div className='offer-content-col'>
        <div className='heading-level-4-b blue-color'>
          {block.contentCards6CardTitle && parser(block.contentCards6CardTitle)}
        </div>
        <p>{block.contentCards6CardSubtitle && parser(block.contentCards6CardSubtitle)}</p>

        {isShown && (
          <div className='fade-in'>{block.contentCards6CardText && parser(block.contentCards6CardText)}</div>
        )}

        <btn
          className='btn blue-arrow-btn blue-text-arrow-btn'
          onClick={handleClick}
        >
          {isShown ? 'Hide' : 'Learn More'}
        </btn>
      </div>
    </div>
  );
};

export default ApproachPrincipalBuilder;
